<template>
    <ion-page class="ion-page" id="main">
        <default-header/>

        <ion-content class="bg-image" fullscreen>
            <background slot="fixed"/>

            <flash-messages/>

            <ion-card v-show="!verifying" class="floating floating-small" style="text-align: center;">
                <ion-card-header>
                    <ion-icon md="shield" ios="shield" style="font-size: 64px; margin: 15px 0 10px;" color="primary"></ion-icon>

                    <ion-card-title>
                        {{ $t('ncrypt.email_verification.page_title') }}
                    </ion-card-title>
                </ion-card-header>

                <ion-card-content>
                    {{ $t('ncrypt.email_verification.intro') }}
                    <br/>
                    <br/>
                    {{ $t('ncrypt.email_verification.intro_check_spam') }}
                    <br/>
                    <br/>

                    <div v-if="this.resentEmail">
                        <ion-text color="success">
                            {{ $t('ncrypt.notifications.resent_verification_email') }}
                        </ion-text>
                    </div>

                    <div v-else-if="this.showResendButton">
                        <ion-button v-if="$store.getters.authed" @click="resend()" size="small" ref="button">
                            <ion-icon md="refresh-circle" ios="refresh-circle" slot="start"></ion-icon>

                            {{ $t('ncrypt.email_verification.resend_button_text') }}
                        </ion-button>

                        <ion-text v-else color="primary">{{ $t('ncrypt.email_verification.login_to_resend_verification_message') }}</ion-text>
                    </div>
                </ion-card-content>
            </ion-card>
        </ion-content>
    </ion-page>
</template>
<script>
    import DefaultHeader from "../../components/nav/DefaultHeader";
    import {ApiError} from "../../errors/ApiError";
    import {ADD_FLASH_MESSAGE} from "../../const/mutation-types";
    import FlashMessages from "../../components/ui-elements/FlashMessages";
    import {Notifier} from "../../services/Notifier";
    import Background from "../Background";

    export default {
        components: {Background, FlashMessages, DefaultHeader},
        data() {
            return {
                verifying: !!this.$route.query.url,
                resentEmail: false,
                resendingEmail: false,
                showResendButton: false,
            }
        },
        async mounted() {
            if (this.$store.getters.authed && this.$store.getters.user.email_verified_at) {
                await this.$router.push({name: 'home'});
                return;
            }

            if (this.$route.query.url) {
                await this.verify();
            }

            setTimeout(() => this.showResendButton = this.$store.getters.authed || this.showResendButton, 4000);
        },
        methods: {
            async verify() {
                const loader = await this.$ionic.loadingController.create({
                    duration: 10000,
                });

                await loader.present();

                this.$http
                    .get(this.$route.query.url)
                    .then(async ({data}) => {
                        if (!data || !data.success) {
                            this.showResendButton = true;
                            new ApiError(this.$t('ncrypt.errors.email_verification.verification_invalid'));
                            return;
                        }

                        await this.$store.dispatch('refreshUser');

                        const emailAddressConfirmed = this.$t('ncrypt.notifications.email_verification.email_address_verified_successfully');

                        await Notifier.showToast({
                            message: emailAddressConfirmed,
                            duration: 5000,
                        });

                        await this.$store.commit(ADD_FLASH_MESSAGE, {
                            message: emailAddressConfirmed,
                            type: 'success',
                        });

                        if (this.$store.getters.userNeedsToEnable2fa) {
                            await this.$store.commit(ADD_FLASH_MESSAGE, {
                                message: this.$t('ncrypt.notifications.configure_2fa_to_send_message'),
                                type: 'success',
                            });

                            await this.$router.push({name: 'security'});
                            return;
                        }

                        await this.$store.dispatch('getOutboxMessagesForPage', 1);

                        const messages = this.$store.getters.outboxMessages;

                        if (messages && messages.length) {
                            await this.$store.commit(ADD_FLASH_MESSAGE, {
                                message: this.$t('ncrypt.notifications.message_was_sent_flash'),
                                type: 'success',
                            });

                            await this.$router.push({name: 'message', params: {id: messages.first().id}});
                            return;
                        }

                        await this.$router.push({name: 'home'});
                    })
                    .catch(error => {
                        this.showResendButton = true;
                        new ApiError(error, true);
                    })
                    .finally(() => {
                        this.verifying = false;
                        loader.dismiss();
                    })
            },
            async resend() {
                this.resendingEmail = true;

                const loader = await this.$ionic.loadingController.create({
                    duration: 10000,
                });

                await loader.present();

                this.$http
                    .get(`/resend-email-verification`)
                    .then(async ({data}) => {
                        if (!data || !data.success) {
                            new ApiError(data);
                            return;
                        }

                        this.resentEmail = true;
                        await Notifier.showToast({
                            message: this.$t('ncrypt.notifications.email_verification.verification_mail_sent'),
                            duration: 5000,
                        });
                    })
                    .catch(error => new ApiError(error, true))
                    .finally(() => {
                        this.resendingEmail = false;
                        loader.dismiss();
                    })
            }
        }
    }
</script>
